import Cartbox from './Cartbox'
import cartboxContainer from './cartboxContainer'

export default cartboxContainer(Cartbox)
